import { actions } from "react-redux-form";
import { httpDownload, httpGet, httpPost } from "../../../../utils/api.utils";
import {
    setInventoryUploadError,
    InventoryUploadModel,
    getInventoryHandlerList,
    getInventoryHandlerUploadTypeList
} from "../../../../constants/model-reducers/external/inventory/inventory-upload/inventory-upload.settings";

export const InventoryUploadFormInitialState = InventoryUploadModel;

const defaultState = () => ({
    inventoryHandlerOptions: []
    , inventoryHandlerUploadTypeOptions: []
    , inventoryUploadError: false
});

const initialState = defaultState();

export const InventoryUploadAction = {

    getInventoryHandlerList: () => async (dispatch, state) => {
        var res = await httpPost('external/inventory/getInventoryHandlerList');

        if (res) {
            dispatch({
                type: getInventoryHandlerList,
                data: res
            })
        }
        else {
            dispatch({
                type: setInventoryUploadError,
                inventoryUploadError: true,
                data: []
            });
        }
    },

    onSelectInventoryHandler: (model, value) => async (dispatch, state) => { 

        const intValue = parseInt(value);

        dispatch(actions.change(model, value));
        dispatch(actions.change("inventoryUploadForm.inventoryHandlerId", intValue))

        var res = await httpPost(`external/inventory/getInventoryHandlerUploadType/${intValue}`) 

        if (res) {
            dispatch({
                type: getInventoryHandlerUploadTypeList,
                data: res
            })
        } else {
            dispatch({
                type: setInventoryUploadError,
                inventoryUploadError: true,
                data: []
            });
        }
    },

    onInventoryUploadTypeSelect: (model, value) => async (dispatch, state) => {
        const intValue = parseInt(value);

        dispatch(actions.change(model, value));
        dispatch(actions.change("inventoryUploadForm.inventoryHandlerUploadTypeId", intValue))
    },

    postExecuteProcess: (UploadId) => () => {
        var url = 'external/adminupload/executePackage';

        httpPost(url, UploadId);
    },

    resetInventoryUploadForm: () => async (dispatch, state) => {
        dispatch(actions.reset('inventoryUploadForm'));
    },

    downloadInventoryUploadTemplate: (fileAttachmentModule, fileName) => async (dispatch, getState) => {
        const encodedFileName = encodeURIComponent(fileName);

        const dealName = sessionStorage.getItem('DealName');
        const newFileName = `ATEM ${dealName} - ${fileName}`;

        try {
            const response = await httpDownload(`common/fileAttachment/downloadFile/${fileAttachmentModule}/${encodedFileName}`);
            if (response.ok) {
                response.blob().then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, newFileName);
                    } else {
                        a.href = downloadUrl;
                        a.download = newFileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                });
            } else {
                dispatch({
                    type: setInventoryUploadError,
                    inventoryUploadError: false,
                })
            }
        } catch (error) {
            dispatch({
                type: setInventoryUploadError,
                inventoryUploadError: false,
            })
        }
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getInventoryHandlerList:
            return {
                ...state,
                inventoryHandlerOptions: action.data
            };
        case getInventoryHandlerUploadTypeList:
            return {
                ...state,
                inventoryHandlerUploadTypeOptions: action.data
            }
        default:
            return state
    }
}